// extracted by mini-css-extract-plugin
module.exports = {"waterfall":"dmbc-base_waterfall-waterfall","noCompleteTips":"dmbc-base_waterfall-noCompleteTips"};